"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPeriodPropType = exports.sortPeriods = void 0;
var prop_types_1 = __importDefault(require("prop-types"));
var DayPeriodPropType = prop_types_1.default.shape({
    startAt: prop_types_1.default.string.isRequired,
    endAt: prop_types_1.default.string.isRequired,
});
exports.DayPeriodPropType = DayPeriodPropType;
function sortPeriods(a, b) {
    return a.startAt.localeCompare(b.startAt);
}
exports.sortPeriods = sortPeriods;
//# sourceMappingURL=_DayPeriod.js.map